<template>
  <div class="map-page">
    <div class="map-page-body flex">
      <div id="amap-body" class="map-page-body-map flex-1" />
      <div class="map-page-body-tool flex-shrink">
        <div class="map-page-body-tool-top flex-row-center">
          <div class="icon flex-center" @click="toTop">
            <img src="@/assets/img/icon-map-top.png">
          </div>
          <div class="icon flex-center" @click="mapPre">
            <img src="@/assets/img/icon-map-pre.png">
          </div>
          <div class="icon flex-center" @click="playTrack">
            <img src="@/assets/img/icon-map-start.png">
          </div>
          <div class="icon flex-center" @click="next">
            <img src="@/assets/img/icon-map-next.png">
          </div>
          <div class="icon flex-center" @click="toBottom">
            <img src="@/assets/img/icon-map-end.png">
          </div>
        </div>
        <div class="map-page-body-tool-list">
          <div class="position-relative">
            <div class="map-page-body-tool-list-percent position-absolute">
              <span class="line position-absolute" :style="{height: percent + '%'}" />
            </div>
            <div v-for="(item, index) in pointCards" :key="index" class="map-page-body-tool-list-item flex-row-center cursor" @click="changeMap(index)">
              <span class="num flex-shrink">
                <p class="flex-center" :class="curClass(index)">{{ index + 1 }}</p>
              </span>
              <span class="text flex-1">
                <p class="tit text-line-1 font-14">{{ item.name }}</p>
                <p class="date font-12 text-line-1">{{ item.startDate }}<span>/</span>{{ item.coordinate }}</p>
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'
import { loadTianditu } from '@/utils/tianditu.js'
export default {
  data() {
    return {
      percent: 0,
      mapIndex: 0,
      pointCards: [],
      maps: '',
      pls: '',
      mapPoint: null,
      trackAni: null,
      animtion: false,
      // 地图实例
      map: null,
      T: null,
      // 标记点数组
      markers: [],
      markerLabels: [],
      // 轨迹线实例
      dynamicPolyline: null, // 动态绘制的轨迹线
      // 轨迹动画点
      animateMarker: null,
      isPlaying: false,
      activeIndex: -1,
      animateTimer: null,
      defaultZoom: 14, // 默认缩放级别
      currentStep: 0, // 当前播放到的地点索引
      currentFrame: 0, // 当前帧（两点间的进度）
      animateSpeed: 30, // 动画速度（ms/步）
      stepCount: 50, // 两点间的步进数（平滑度）
      dynamicPath: [], // 动态轨迹线的路径
      baseStepSpeed: 0.2 // 基础步速（米/秒）
    }
  },
  mounted() {
    this.request()
  },
  beforeDestroy() {
    this.pauseTrack()
    if (this.map) {
      try { this.map.clearOverLays() } catch (e) { /* ignore */ }
      this.map = null
    }
  },
  methods: {
    request() {
      api.getEventList({
        trajectory: 1,
        field: 'startDate',
        asc: 1,
        page: 1,
        limit: 100
      }).then(res => {
        if (res.code === 2000) {
          res.items.data.forEach(item => {
            const p = item.mapPlace.split(',')
            item.mapPlace = [parseFloat(p[0]), parseFloat(p[1])]
          })
          this.pointCards = res.items.data
          setTimeout(() => {
            this.loadMap()
          }, 500)
        }
      })
    },
    curClass(val) {
      if (val < this.activeIndex) {
        return 'num-pass'
      } else if (val === this.activeIndex) {
        return 'num-cursel'
      } else {
        return ''
      }
    },
    update(e) {
      this.points = e.target.cornerPoints
    },
    /**
     * 天地图坐标点构造
     */
    toLngLat(lng, lat) {
      return new this.T.LngLat(lng, lat)
    },
    showOverlay(overlay) {
      if (!this.map || !overlay) return
      try { this.map.removeOverLay(overlay) } catch (e) { /* ignore */ }
      this.map.addOverLay(overlay)
    },
    hideOverlay(overlay) {
      if (!this.map || !overlay) return
      try { this.map.removeOverLay(overlay) } catch (e) { /* ignore */ }
    },
    /**
     * 重置轨迹
     */
    resetTrack() {
      this.pauseTrack()
      // 1. 重置所有状态
      this.activeIndex = -1
      this.currentStep = 0
      this.currentFrame = 0
      this.dynamicPath = []

      // 2. 清除所有标记和轨迹
      this.hideOverlay(this.dynamicPolyline)
      this.dynamicPolyline = null
      this.markers.forEach((marker, i) => {
        this.hideOverlay(marker)
        this.hideOverlay(this.markerLabels[i])
      })

      // 3. 回到地图起点
      if (this.map && this.T && this.pointCards.length) {
        this.map.panTo(this.toLngLat(
          this.pointCards[0].mapPlace[0],
          this.pointCards[0].mapPlace[1]
        ))
      }
    },
    /**
     * 暂停轨迹播放
     */
    pauseTrack() {
      this.isPlaying = false
      if (this.animateTimer) {
        clearInterval(this.animateTimer)
        this.animateTimer = null
      }
    },
    changeMap(index) {
      this.pauseTrack()
      if (this.activeIndex === index || !this.map || !this.T) {
        return
      }
      this.activeIndex = index
      this.percent = parseFloat(index) / parseFloat(this.pointCards.length - 1) * 100

      this.hideOverlay(this.dynamicPolyline)
      this.dynamicPolyline = null
      this.dynamicPath = []

      this.markers.forEach((marker, i) => {
        this.hideOverlay(marker)
        this.hideOverlay(this.markerLabels[i])
      })

      // 2. 显示当前点击的标记（仅图标，不显示序号标签）
      const currentMarker = this.markers[index]
      this.showOverlay(currentMarker)

      // 3. 定位到该点
      this.map.panTo(this.toLngLat(
        this.pointCards[index].mapPlace[0],
        this.pointCards[index].mapPlace[1]
      ))
      this.map.setZoom(9) // 放大至9级
      this.activeIndex = index
    },
    loadMap() {
      this.createMapInstance()
    },
    createMapInstance() {
      loadTianditu().then(T => {
        this.T = T
        const center = new T.LngLat(this.pointCards[0].mapPlace[0], this.pointCards[0].mapPlace[1])
        this.map = new T.Map(document.getElementById('amap-body'))
        this.map.centerAndZoom(center, this.defaultZoom)
        this.map.enableScrollWheelZoom()
        this.initMarkers()
        this.changeMap(0)
      }).catch(err => {
        console.error('天地图初始化失败', err)
      })
    },

    /**
     * 播放轨迹动画
     */
    playTrack() {
      if (this.isPlaying || !this.map || !this.T) {
        this.pauseTrack()
        return
      }

      this.isPlaying = true
      this.currentStep = 0 // 从第0个地点开始
      this.currentFrame = 0 // 初始帧
      this.activeIndex = 0 // 高亮起点
      this.dynamicPath = [] // 清空动态路径

      // 清除已有覆盖物
      this.hideOverlay(this.dynamicPolyline)
      this.dynamicPolyline = null
      this.markers.forEach((marker, i) => {
        this.hideOverlay(marker)
        this.hideOverlay(this.markerLabels[i])
      })

      // 1. 获取第一个地点坐标（动画起始点）
      const startPoint = this.pointCards[0]
      const startLngLat = this.toLngLat(startPoint.mapPlace[0], startPoint.mapPlace[1])

      // 2. 缩放到动画级别（zoom=4），并定位到第一个地点
      this.map.centerAndZoom(startLngLat, 4)

      // 3. 初始化动态轨迹线
      this.dynamicPath = [this.toLngLat(
        this.pointCards[0].mapPlace[0],
        this.pointCards[0].mapPlace[1]
      )]
      this.dynamicPolyline = new this.T.Polyline(this.dynamicPath, {
        strokeColor: '#FFF7AA',
        strokeWeight: 4,
        strokeOpacity: 0.8,
        strokeStyle: 'solid'
      })
      this.map.addOverLay(this.dynamicPolyline)

      // 开始动画
      this.startAnimate()
    },

    /**
     * 轨迹动画核心逻辑
     */
    startAnimate() {
      if (!this.isPlaying || !this.map || !this.T) {
        this.isPlaying = false
        return
      }

      // 播放完成
      if (this.currentStep >= this.pointCards.length - 1) {
        this.isPlaying = false
        return
      }

      const startPoint = this.pointCards[this.currentStep].mapPlace
      const endPoint = this.pointCards[this.currentStep + 1].mapPlace
      // 核心：需求2 - 动态计算stepCount（根据距离）
      const stepCount = this.getDynamicStepCount(
        startPoint[1],
        startPoint[0],
        endPoint[1],
        endPoint[0]
      )
      // 根据速度调整步进数（速度越慢，步进数越多，越平滑）
      const stepLat = (endPoint[1] - startPoint[1]) / stepCount
      const stepLng = (endPoint[0] - startPoint[0]) / stepCount
      this.animateTimer = setInterval(() => {
        // 1. 帧计数+1
        this.currentFrame++

        // 2. 计算当前帧的位置
        const currentLat = startPoint[1] + stepLat * this.currentFrame
        const currentLng = startPoint[0] + stepLng * this.currentFrame
        const currentPos = this.toLngLat(currentLng, currentLat)

        // 核心：需求1 - 镜头跟随动画移动
        this.map.panTo(currentPos)

        // 4. 更新动态轨迹线（添加当前帧位置）
        this.dynamicPath.push(currentPos)
        if (this.dynamicPolyline) {
          if (this.dynamicPolyline.setLngLats) {
            this.dynamicPolyline.setLngLats(this.dynamicPath)
          } else if (this.dynamicPolyline.setPoints) {
            this.dynamicPolyline.setPoints(this.dynamicPath)
          }
        }

        // 3. 到达终点
        if (this.currentFrame >= stepCount) {
          clearInterval(this.animateTimer)
          this.animateTimer = null
          this.currentStep++
          this.currentFrame = 0 // 重置帧计数
          this.activeIndex = this.currentStep // 高亮当前到达的点

          // 定位到当前点
          this.map.panTo(this.toLngLat(endPoint[0], endPoint[1]))

          // 继续下一段动画
          this.startAnimate()
        }
      }, this.animateSpeed)
    },

    /**
     * 计算两点之间的距离（米）
     */
    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 6371000 // 地球半径（米）
      const radLat1 = Math.PI * lat1 / 180
      const radLat2 = Math.PI * lat2 / 180
      const deltaLat = Math.PI * (lat2 - lat1) / 180
      const deltaLng = Math.PI * (lng2 - lng1) / 180

      // 哈弗辛公式
      const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
                Math.cos(radLat1) * Math.cos(radLat2) *
                Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c // 距离（米）
    },

    /**
     * 根据距离计算动态stepCount（保证视觉速度一致）
     */
    getDynamicStepCount(startLat, startLng, endLat, endLng) {
      if (!this.map || !this.T) return 50

      // 1. 计算实际距离（米）
      const distance = this.calculateDistance(startLat, startLng, endLat, endLng)

      // 2. 将距离转换为地图像素（根据当前缩放级别）
      let pixelDistance = 0
      try {
        const startPoint = this.map.lngLatToContainerPoint(this.toLngLat(startLng, startLat))
        const endPoint = this.map.lngLatToContainerPoint(this.toLngLat(endLng, endLat))
        pixelDistance = Math.sqrt(
          Math.pow(endPoint.x - startPoint.x, 2) +
          Math.pow(endPoint.y - startPoint.y, 2)
        )
      } catch (e) {
        // 投影不可用时按地理距离估算
        pixelDistance = Math.max(distance / 1000, 10)
      }

      // 3. 根据基础步速计算stepCount（保证视觉速度一致）
      const stepCount = Math.max(Math.round(pixelDistance / this.baseStepSpeed), 10)
      return stepCount
    },

    initMarkers() {
      this.markers = []
      this.markerLabels = []
      this.pointCards.forEach((item, index) => {
        const position = this.toLngLat(item.mapPlace[0], item.mapPlace[1])
        const marker = new this.T.Marker(position)
        marker.addEventListener('click', () => {
          // 存储当前标记的所有数据信息
          const markerData = {
            index: index, // 标记索引
            data: { ...item } // 标记原始数据（深拷贝）
          }
          // 4. 可选：执行其他业务逻辑
          this.handleMarkerClick(markerData)
        })

        const label = new this.T.Label({
          text: `${index + 1}`,
          position,
          offset: new this.T.Point(0, -30)
        })

        this.markers.push(marker)
        this.markerLabels.push(label)
      })
    },

    handleMarkerClick(v) {
      const page = this.$router.resolve({
        path: '/entity',
        query: {
          cateId: '013004',
          sourceId: v.data.id
        }
      })
      window.open(page.href, '_blank')
    },
    next() {
      if (this.isPlaying) {
        this.pauseTrack()
      }
      if (this.activeIndex === this.pointCards.length - 1) {
        return
      }
      // this.mapIndex += 1
      this.percent = parseFloat(this.activeIndex + 1) / parseFloat(this.pointCards.length - 1) * 100
      this.changeMap(this.activeIndex + 1)
    },
    mapPre() {
      if (this.isPlaying) {
        this.pauseTrack()
      }
      if (this.activeIndex < 1) {
        return
      }
      this.percent = parseFloat(this.activeIndex - 1) / parseFloat(this.pointCards.length - 1) * 100
      this.changeMap(this.activeIndex - 1)
    },
    toTop() {
      if (this.isPlaying) {
        this.pauseTrack()
      }
      if (this.activeIndex === 0) {
        return
      }
      this.percent = 0
      this.changeMap(0)
    },
    toBottom() {
      if (this.isPlaying) {
        this.pauseTrack()
      }
      if (this.activeIndex === this.pointCards.lengt - 1) {
        return
      }
      this.percent = 100
      this.changeMap(this.pointCards.length - 1)
    },
    showLocation() {
      const allOverlays = this.maps.getOverlays()// 返回地图上所有的覆盖物
      // 循环找到数组里面id和返回覆盖物相同的
      for (let i = 0; i < allOverlays.length; i++) {
        this.maps.removeOverlay(allOverlays[i])
      }
      const value = this.path[this.mapIndex]
      // eslint-disable-next-line
      var marker1 = new BMapGL.Marker(new BMapGL.Point(value.mapPlace[0], value.mapPlace[1]));
      // eslint-disable-next-line
      this.maps.centerAndZoom(new BMapGL.Point(value.mapPlace[0], value.mapPlace[1]), 6)
      this.maps.addOverlay(marker1)
    }
  }
}
</script>

<style scoped>
  .map-page {
    padding: 20px 0;
  }

  .map-page-body-map {
    height: 800px;
  }

  .map-page-body-tool {
    width: 240px;
    height: 800px;
    border: 1px solid #EEEEEE;
    backdrop-filter: blur(100px);
    border-radius: 0px 5px 5px 0px;
  }

  .map-page-body-tool-top {
    height: 40px;
    padding: 0 20px;
    border: 1px solid #EEEEEE;
  }

  .map-page-body-tool-top .icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 5px;
    border: 1px solid #FAFAFA;
    cursor: pointer;
  }

  .map-page-body-map-view {
    width: 100%;
    height: 100%;
  }

  .map-page-body-tool-list {
    height: 760px;
    overflow: scroll;
  }

  .map-page-body-tool-list-percent {
    top: 20px;
    left: 26px;
    bottom: 36px;
    background-color: #999;
    width: 2px;
    z-index: -1;
  }

  .map-page-body-tool-list-percent .line {
    background-color: #A21E1E;
    top: 0;
    left: 0;
    width: 2px;
    height: 0.5%;
    transition: 2s;
  }

  .map-page-body-tool-list-item {
    height: 65px;
    padding: 0 20px;
  }

  .map-page-body-tool-list-item .num {
    margin-right: 10px;
  }

  .map-page-body-tool-list-item .num p {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: #999999;
    color: #fff;
    font-size: 8px;
    margin-top: -17px;
    transition: .5s;
  }

  .map-page-body-tool-list-item .num p.num-pass{
    border: 1px solid #A21E1E;
    background-color: #fff;
    color: #A21E1E;
  }

  .map-page-body-tool-list-item .num p.num-cursel{
    background: #A21E1E;
  }

  .map-page-body-tool-list-item .text .tit {
    line-height: 20px;
    color: #1A1A1A;
  }

  .map-page-body-tool-list-item .text .date {
    color: #999999;
    line-height: 20px;
  }

  .map-page-body-tool-list-item .text .date span {
    color: #EEEEEE;
    margin: 0 5px;
  }

</style>
